import { Page } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { useMount, useUnmount } from 'react-use';

import { dashboardApi } from 'apis/dashboard';
import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { useDashboardRefetchEffect } from 'utils/dashboard';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { DashboardError } from '../../components/error/dashboardError';
import { DashboardHeader } from '../../components/header/dashboardHeader';
import { dashboardActions } from '../../dashboard.actions';
import rootStyles from '../../dashboard.view.module.scss';

import styles from './channelDashboard.view.module.scss';
import { ChannelDashboardChannels } from './components/channels/channelDashboardChannels';
import { ChannelDashboardControls } from './components/controls/channelDashboardControls';

export const ChannelDashboardView = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const { isError, refetch } =
    dashboardApi.useReadChannelDashboardMetricsQuery();

  useDashboardRefetchEffect({ refetch });

  useMount(() => {
    ampli.dashboardViewed({ version: 'channels' });

    dispatch(
      websocketActions.request({
        type: 'connection:subscribe',
        params: {
          type: 'real_time_dashboard',
          dashboard_type: 'channel',
        },
      }),
    );

    return () => {
      dispatch(
        websocketActions.request({
          type: 'connection:unsubscribe',
          params: {
            type: 'real_time_dashboard',
            dashboard_type: 'channel',
          },
        }),
      );
    };
  });

  useUnmount(() => {
    dispatch(
      dashboardActions.setLastVisitedUrl({
        path: '/dashboard/channels',
      }),
    );
  });

  const renderContent = (): JSX.Element => {
    if (isError) {
      return <DashboardError />;
    }

    return <ChannelDashboardChannels />;
  };

  return (
    <Page>
      <Page.Head
        className={rootStyles.pageHead}
        title={<DashboardHeader dashboard="channel" />}
        controls={<ChannelDashboardControls />}
      />

      <Page.Body>
        <Page.Section>
          <div className={styles.root}>{renderContent()}</div>
        </Page.Section>
      </Page.Body>
    </Page>
  );
};
